import type { ChainArch } from "@opensea/graphql"
import { PublicKey } from "@solana/web3.js"
import { isAddress as isEvmAddress } from "viem"

export const isEnsName = (identifier: string) => identifier.endsWith(".eth")

export const isSolanaAddress = (identifier: string) => {
  try {
    const publicKey = new PublicKey(identifier)
    return PublicKey.isOnCurve(publicKey.toBytes())
  } catch {
    return false
  }
}

export const isAddress = (identifier: string) => {
  return isEvmAddress(identifier) || isSolanaAddress(identifier)
}

export const getChainArchFromAddress = (
  identifier: string,
): ChainArch | undefined => {
  if (isEvmAddress(identifier)) {
    return "EVM"
  }
  if (isSolanaAddress(identifier)) {
    return "SVM"
  }
  return undefined
}

export { isEvmAddress }
